import { useState, useEffect } from 'react';

interface DeviceDetection {
  isDesktop: boolean;
  isMobile: boolean;
  isTablet: boolean;
  screenWidth: number;
}

export const useDeviceDetection = (): DeviceDetection => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceDetection>({
    isDesktop: true,
    isMobile: false,
    isTablet: false,
    screenWidth: typeof globalThis.window === 'undefined' ? 1920 : globalThis.window.innerWidth
  });

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      const userAgent = navigator.userAgent.toLowerCase();
      
      // Check for mobile devices
      const isMobileDevice = /iphone|ipod|android|blackberry|windows phone|mobile/i.test(userAgent);
      
      // Check for tablets (including iPad)
      const isTabletDevice = /ipad|android(?!.*mobile)|tablet|kindle|silk/i.test(userAgent);
      
      // Screen width based detection (desktop is >= 1024px)
      const isDesktopWidth = width >= 1024;
      
      // Combine checks: desktop if screen is large AND not mobile/tablet device
      const isDesktop = isDesktopWidth && !isMobileDevice && !isTabletDevice;
      
      setDeviceInfo({
        isDesktop,
        isMobile: isMobileDevice || (width < 768 && !isTabletDevice),
        isTablet: isTabletDevice || (width >= 768 && width < 1024),
        screenWidth: width
      });
    };

    // Initial check
    checkDevice();

    // Listen for window resize
    window.addEventListener('resize', checkDevice);
    
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return deviceInfo;
};
